module.exports = __webpack_public_path__ + "img/1.2df4957f.jpg";